export function getPathname(url: string | null = ""): string {
  if (url) return new URL(url).pathname;
  return "/";
}
